// extracted by mini-css-extract-plugin
export default {"pb5":"Modal_pb5__+Y5za"};